import { Const } from './global.definition';

export const ToastSeverityType = {
  INFO: 'info',
  SUCCESS: 'success',
  WARN: 'warn',
  ERROR: 'error',
} as const;

export type ToastProps = {
  summary: string;
  severity?: Const<typeof ToastSeverityType>;
  detail?: string;
};
